import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { toast } from "react-toastify";

//CUSTOM COMPONENT
import Area from "../../aGlobalDesign/Area/Area";

import PortalAgentsList from "./PortalAgentsList";
import DisplaysList from "./DisplaysList";
import CallApp from "../CallGestion/URLCalls/CallApp";

class DisplaysContainer extends React.Component {

    constructor() {
        super();
        this.state = {
            reload: new URLSearchParams(new URL(window.location.href).search).get("reload"),
            reloadKey: 0,
            createNew: 0,
            selectedPage: "agentportals"
        };
    }
    componentDidMount() {
        this.props.toggleMonitoringMenu();
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedDisplay: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        const reload = new URLSearchParams(new URL(window.location.href).search).get("reload");
        if (reload && this.state.reload !== reload) {
            this.setState({ reload: reload });
            this.forcePaginationUpdate();
        }
    }

    getNavigationList() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const list = [];
        if (accessrights && accessrights.hasPermission(80, "consult") > 10) {
            list.push({
                id: "agentportals",
                title: strings.PortalsAgentTablet,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "agentportals",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        if (accessrights && accessrights.hasPermission(90, "consult") > 10) {
            list.push({
                id: "clientportals",
                title: strings.PortalsClientCapsule,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "clientportals",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        if (accessrights && accessrights.hasPermission(410, "consult") > 10) {
            list.push({
                id: "webcalls",
                title: strings.CallApp,
                onSelect: () => this.setState(prev => ({
                    selectedPage: "webcalls",
                    reloadKey: prev.reloadKey + 1
                }))
            });
        }
        return list;
    }
    getSideButtonsList() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const sb = {
            type: "primary-icon",
            nameIcon: "add",
            text: "Nouveau",
            onClick: () => this.setState({ createNew: this.state.createNew + 1 })
        };
        if (this.state.selectedPage == "agentportals" && accessrights && accessrights.hasPermission(80, "create") <= 10) {return [];}
        if (this.state.selectedPage == "clientportals" && accessrights && accessrights.hasPermission(90, "create") <= 10) {return [];}
        if (this.state.selectedPage == "webcalls") {return [];}
        return [sb];
    }

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : null;
        const isSystemAdministrator = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.user.isSystemAdministrator;
        return <>
            <Area
                helmet={strings.helmetPortals}
                title={strings.portals}
                navigatedId={this.state.selectedPage}
                navigation={this.getNavigationList()}
                sideButtons={this.getSideButtonsList()}
            >
                {
                    this.state.selectedPage == "agentportals" ? <PortalAgentsList
                        reload={this.state.reload}
                        key={`agentportals-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }
                {
                    this.state.selectedPage == "clientportals" ? <DisplaysList
                        reload={this.state.reload}
                        key={`clientportals-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }
                {
                    this.state.selectedPage == "webcalls" ? <CallApp
                        reload={this.state.reload}
                        key={`webcalls-${this.state.reloadKey}`}
                        createNew={this.state.createNew}
                    /> : null
                }
            </Area>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(DisplaysContainer);
